<template>
  <n-config-provider :theme="naiveTheme">
    <n-message-provider>
      <MessageBootstrap />
      <div
        id="app-canvas"
        class="app-root bg-background text-text-main"
        :class="{ 'app-root--scroll': isFullscreen }"
      >
        <router-view />
        <GlobalModals />
      </div>
    </n-message-provider>
  </n-config-provider>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { NConfigProvider, NMessageProvider, darkTheme } from 'naive-ui'
import { useTheme } from '@/composables/useTheme'
import GlobalModals from '@/components/common/GlobalModals.vue'
import MessageBootstrap from '@/components/common/MessageBootstrap.vue'

// Initialize theme system - this will apply the theme immediately
const { isDark } = useTheme()

// Configure Naive UI theme based on current theme
const naiveTheme = computed(() => {
  return isDark.value ? darkTheme : null
})

const route = useRoute()

// 认证页等独立页面（登录/注册/忘记密码）需要自身可滚动；其余页面由 AppLayout 内部滚动。
// 应用整体铺满真实视口，不再做等比缩放，因此任何分辨率下版式一致。
const isFullscreen = computed(() => !!route.meta.fullscreen)
</script>

<style>
/* Global styles are imported in main.ts */
html,
body {
  margin: 0;
  height: 100%;
  overflow: hidden;
  background: transparent;
}

#app {
  width: 100%;
  height: 100%;
  /* n-config-provider / n-message-provider 会渲染出中间包裹 div（.n-config-provider）。
     若不撑满这层，内部 .app-root 的 height:100% 会相对 auto 高度解析，退化成内容高度，
     应用就会只占据视口上方一小块。 */
  display: flex;
  flex-direction: column;
}

#app > * {
  flex: 1 1 auto;
  min-height: 0;
}

/* 应用根容器：铺满视口，内部各区域自行滚动 */
.app-root {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* 认证页等独立页面：根容器改为可滚动 */
.app-root--scroll {
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
